// router
// common
import IQCMenuPage from '@/components/pages/common/IQCMenuPage'
import MasterMenuPage from '@/components/pages/common/MasterMenuPage'
import MenuRootPage from '@/components/pages/common/MenuRootPage'
import OQCMenuPage from '@/components/pages/common/OQCMenuPage'
import RootPage from '@/components/pages/common/RootPage'
import SignIn from '@/components/pages/common/SignIn'
import TopMenuPage from '@/components/pages/common/TopMenuPage'
import CheckLatestPartsPage from '@/components/pages/master/check-latest-parts/CheckLatestPartsPage.vue'
import ReportRootPage from '@/components/pages/common/ReportRootPage.vue'
// master
import CompanyPage from '@/components/pages/master/company/CompanyPage'
import DefectGroupPage from '@/components/pages/master/defect-group/DefectGroupPage'
import DefectPage from '@/components/pages/master/defect/DefectPage'
import InspAttatchmentPage from '@/components/pages/master/insp-attatchment/InspAttatchmentPage'
import InspCharacPage from '@/components/pages/master/insp-charac/InspCharacPage'
import MeasInstPage from '@/components/pages/master/meas-inst/MeasInstPage'
import PartPage from '@/components/pages/master/part/PartPage'
import UserPage from '@/components/pages/master/user/UserPage'
import InspFilteringUpdatePage from '@/components/pages/master/insp-filtering-update/InspFilteringUpdatePage'
import XrfGroupPage from '@/components/pages/master/xrf-group/XrfGroupPage'
// report
import DefectParetoChartPage from '@/components/pages/report/defect-pareto-chart/DefectParetoChartPage'
import DefectRatePage from '@/components/pages/report/defect-rate/DefectRatePage.vue'
import MeasValuePlotChartPage from '@/components/pages/report/meas-value-plot-chart/MeasValuePlotChartPage'
import InspLoadPage from '@/components/pages/report/insp-load/InspLoadPage'
import DefectRatePageReport from '@/components/pages/report/defect-rate/DefectRatePageReport.vue'
import InspLoadPageReport from '@/components/pages/report/insp-load/InspLoadPageReport.vue'
import InspectionResultSummaryPage from '@/components/pages/report/insp-result-summary/InspResultSummaryPage.vue'
import InspResultReportPage from '@/components/pages/report/insp-result-report/InspResultReportPage'
// terminal
import AnalyzeRecordPage from '@/components/pages/terminal/analyze-record/AnalyzeRecordPage'
import ApproveInspDataPage from '@/components/pages/terminal/approve-insp-data/ApproveInspDataPage'
import BoxInformationPage from '@/components/pages/terminal/box-info/BoxInfoPage'
import DelInspData from '@/components/pages/terminal/del-insp-data/DelInspData'
import EditInspIndexPage from '@/components/pages/terminal/edit-insp-index/EditInspIndexPage'
import EditReturnRecordPage from '@/components/pages/terminal/edit-return-record/EditReturnRecordPage'
import ExportInspDataCSV from '@/components/pages/terminal/export-insp-data-csv/ExportInspDataCSV'
import ImportInspData from '@/components/pages/terminal/imp-insp-data/ImpInspDataPage.vue'
import ImpInspIndexPage from '@/components/pages/terminal/imp-insp-index/ImpInspIndexPage'
import ImpInspLotPage from '@/components/pages/terminal/imp-insp-lot/ImpInspLotPage'
import InputAppInspPage from '@/components/pages/terminal/input-app-insp/InputAppInspPage'
import InputDimInspPage from '@/components/pages/terminal/input-dim-insp/InputDimInspPage'
import ReturnRecordPage from '@/components/pages/terminal/return-record/ReturnRecordPage'
import SaRequestPage from '@/components/pages/terminal/sa-request/SaRequestPage'
import SearchInspBoxPage from '@/components/pages/terminal/search-insp-box/SearchInspBoxPage'
import SearchInspIndexPage from '@/components/pages/terminal/search-insp-index/SearchInspIndexPage'
import SearchInspLotPage from '@/components/pages/terminal/search-insp-lot/SearchInspLotPage'
import SearchInspResultPage from '@/components/pages/terminal/search-insp-result/SearchInspResultPage'
import SearchSaHistoryPage from '@/components/pages/terminal/search-sa-history/SearchSaHistoryPage'
import SearchXRFInspExpDatePage from '@/components/pages/terminal/search-xrf-insp-exp/SearchXRFInspExpDate'
import SearchSaDetailPage from '@/components/pages/terminal/search-sa-detail/SearchSaDetailPage'
import SearchMmmmHistoryPage from '@/components/pages/terminal/search-mmmm-history/SearchMmmmHistoryPage'
import MmmmRequestPage from '@/components/pages/terminal/mmmm-request/MmmmRequestPage'
import InputXrfInspPage from '@/components/pages/terminal/input-xrf-insp/InputXrfInspPage'
import SearchInspPrerequisitePage from '@/components/pages/terminal/search-insp-prerequisite/SearchInspPrerequisitePage'
// util
import i18n from '@/lang'
import store from '@/store/index'
import Axios from 'axios'
import Vue from 'vue'
import VueRouter from 'vue-router'
import { Env } from '@/plugins/env'
import Amplify from '@aws-amplify/core'

Vue.use(VueRouter)

//pathの設定
let routes = [
  {
    path: '/sign-in',
    name: 'SignIn',
    component: SignIn,
  },
  {
    path: '/',
    component: MenuRootPage,
    children: [
      {
        path: '',
        name: 'TopMenu',
        component: TopMenuPage,
        meta: { requiresAuth: true, isMenu: true },
      },
    ]
  },
  {
    path: '/report',
    component: ReportRootPage,
    children: [
      {
        path: '/report/defect-rate',
        name: 'DefectRatePageReport',
        component: DefectRatePageReport,
        props: true
      },
      {
        path: '/report/insp-load',
        name: 'InspLoadPageReport',
        component: InspLoadPageReport,
        props: true
      },
      {
        path: '/report/insp-result-report',
        name: 'R06',
        component: InspResultReportPage,
        meta: { requiresAuth: true },
      },
    ]
  },
  {
    path: '/',
    component: RootPage,
    children: [
      {
        path: '/menu-oqc',
        name: 'OQCMenu',
        component: OQCMenuPage,
        meta: { requiresAuth: true, isMenu: true },
      },
      {
        path: '/menu-iqc',
        name: 'IQCMenu',
        component: IQCMenuPage,
        meta: { requiresAuth: true, isMenu: true },
      },
      {
        path: '/menu-master',
        name: 'MasterMenu',
        component: MasterMenuPage,
        meta: { requiresAuth: true, isMenu: true },
      },
      {
        path: '/company',
        name: 'M01',
        component: CompanyPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/part',
        name: 'M02',
        component: PartPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/insp-charac',
        name: 'M03',
        component: InspCharacPage,
        meta: { requiresAuth: true }
      },
      {
        path: '/insp-attatchment',
        name: 'M04',
        component: InspAttatchmentPage,
        meta: { requiresAuth: true }
      },
      {
        path: '/user',
        name: 'M05',
        component: UserPage,
        meta: { requiresAuth: true }
      },
      {
        path: '/meas-inst',
        name: 'M06',
        component: MeasInstPage,
        meta: { requiresAuth: true }
      },
      {
        path: '/defect',
        name: 'M07',
        component: DefectPage,
        meta: { requiresAuth: true }
      },
      {
        path: '/defect-group',
        name: 'M08',
        component: DefectGroupPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/check-latest-parts',
        name: 'M09',
        component: CheckLatestPartsPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/insp-filtering-update',
        name: 'M10',
        component: InspFilteringUpdatePage,
        meta: { requiresAuth: true },
      },
      {
        path: '/imp-insp-index',
        name: 'T01',
        component: ImpInspIndexPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/search-insp-index',
        name: 'T02',
        component: SearchInspIndexPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/edit-insp-index',
        name: 'T03',
        component: EditInspIndexPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/box-info',
        name: 'T04',
        component: BoxInformationPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/search-insp-box',
        name: 'T05',
        component: SearchInspBoxPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/imp-insp-lot',
        name: 'T14',
        component: ImpInspLotPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/search-insp-result',
        name: 'T09',
        component: SearchInspResultPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/input-app-insp',
        name: 'T10',
        component: InputAppInspPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/input-dim-insp',
        name: 'T11',
        component: InputDimInspPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/imp-insp-data',
        name: 'T12',
        component: ImportInspData,
        meta: { requiresAuth: true },
      },
      {
        path: '/export-insp-data-csv',
        name: 'T13',
        component: ExportInspDataCSV,
        meta: { requiresAuth: true },
      },
      {
        path: '/search-insp-lot',
        name: 'T15',
        component: SearchInspLotPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/search-xrf-insp-exp',
        name: 'T16',
        component: SearchXRFInspExpDatePage,
        meta: { requiresAuth: true },
      },
      {
        path: '/del-insp-data',
        name: 'T17',
        component: DelInspData,
        meta: { requiresAuth: true },
      },
      {
        path: '/approve-insp-data',
        name: 'T19',
        component: ApproveInspDataPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/search-return-record',
        name: 'T26',
        component: ReturnRecordPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/edit-return-record',
        name: 'T27',
        component: EditReturnRecordPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/analyze-record',
        name: 'T28',
        component: AnalyzeRecordPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/search-mmmm-history',
        name: 'T29',
        component: SearchMmmmHistoryPage,
        meta: { requiresAuth: true, defaultQuery: { isWaiting: true } },
      },
      {
        path: '/mmmm-request',
        name: 'T30',
        component: MmmmRequestPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/input-xrf-insp',
        name: 'T31',
        component: InputXrfInspPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/search-insp-prerequisite',
        name: 'T32',
        component: SearchInspPrerequisitePage,
        meta: { requiresAuth: true },
      },
      {
        path: '/defect-pareto-chart',
        name: 'R01',
        component: DefectParetoChartPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/defect-rate',
        name: 'R03',
        component: DefectRatePage,
        meta: { requiresAuth: true }
      },
      {
        path: '/meas-value-plot-chart',
        name: 'R02',
        component: MeasValuePlotChartPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/insp-load',
        name: 'R04',
        component: InspLoadPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/insp-result-summary',
        name: 'R05',
        component: InspectionResultSummaryPage,
        meta: { requiresAuth: true },
      },
      {
        path: '/xrf-group',
        name: 'M11',
        component: XrfGroupPage,
        meta: { requiresAuth: true },
      },
    ]
  },
]

if (process.env.VUE_APP_CAN_REQUEST_SA) {
  if (process.env.VUE_APP_CAN_REQUEST_SA === 'true') {
    routes[3].children.push({
      path: '/search-sa-history',
      name: 'T06',
      component: SearchSaHistoryPage,
      meta: { requiresAuth: true, defaultQuery: { isWaiting: true } },
    })
    routes[3].children.push({
      path: '/sa-request',
      name: 'T07',
      component: SaRequestPage,
      meta: { requiresAuth: true },
    })
  } else if(process.env.VUE_APP_CAN_REQUEST_SA === 'false') {
    routes[3].children.push({
      path: '/search-sa-history',
      name: 'T06',
      component: SearchSaHistoryPage,
      meta: { requiresAuth: true },
    })
    routes[3].children.push({
      path: '/search-sa-detail',
      name: 'T07',
      component: SearchSaDetailPage,
      meta: { requiresAuth: true },
    })
  }
  else {
    // ミス等で環境変数が取得できない場合、なにもしない
  }
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeResolve(async (to, _from, next) => {
  // message、loadingコンポーネント初期化
  store.dispatch('doSetMessageInfo', { type: '', message: '' })
  store.dispatch('doSetLoading', { loading: false })

  // 機能タイトル設定
  const func = store.getters.allowedFunctions.find((v) => v.functionCd == to.name);
  const functionCd = func ? func.functionCd : ""
  const functionTitle = func ? func.functionName : i18n.t("ELE0001")
  store.dispatch('doSetFunction', { functionCd: functionCd, functionTitle: functionTitle })

  // 認可制御不要
  if (!to.matched.some((record) => record.meta.requiresAuth)) {
    next()
  } else {
    // ログインしていない場合、saml連携からの遷移の場合はログイン実行、それ以外はログイン画面へ遷移する
    if (!store.getters.isLoggedIn) {
      if (Env.isSingleSignOn()) {
        const url_obj = getSearchObj(location.search);
        if (url_obj != '') {
          try {
            await signIn(url_obj.code)
            // ログイン成功
            next()
          } catch {
            // ログイン失敗 ログイン画面へ遷移
            next({ path: '/sign-in', query: { redirect: to.fullPath } })
          }
        } else {
          // saml連携のcodeがURLに無い場合は ログイン画面へ遷移する
          next({ path: '/sign-in', query: { redirect: to.fullPath } })
        }
      } else {
        next({ path: '/sign-in', query: { redirect: to.fullPath } })
      }

      // メニューへ遷移
    } else if (to.matched.some((record) => record.meta.isMenu)) {
      next()
      // 遷移先機能が認可されていない場合、メニューへリダイレクト
    } else if (!store.getters.allowedFunctions.some((v) => v.functionCd == to.name)) {
      next({ path: '/', query: { redirect: to.fullPath } })
    }
    else {
      if (Object.keys(to.query).length === 0 && to.matched.some((record) => record.meta.defaultQuery)) {
        next({name: to.name,  query: to.meta.defaultQuery })
      } else {
        next()
      }
    }
  }
})

function getSearchObj(searchStr) {
  if (!searchStr) return {};
  return searchStr
    .substr(1)
    .split("&")
    .reduce((acc, cur) => {
      acc[cur.split("=")[0]] = cur.split("=")[1];
      return acc;
    }, {});
}

function signIn(code) {
  return new Promise(function (resolve, reject) {
    let params = new URLSearchParams();
    let config = null
    if (store.getters.isEMSOnly) {
      config = { REDIRECT_URL: process.env.VUE_APP_WEB_URI, IDENTITY_PROVIDER: 'azureAD', CLIENT_ID: process.env.VUE_APP_EMS_USER_POOL_CLIENT_ID, COG_URL: process.env.VUE_APP_EMS_COGNITO_URI, ID_POOL_ID: process.env.VUE_APP_EMS_ID_POOL_ID, USER_POOL_ID: process.env.VUE_APP_EMS_USER_POOL_ID }
    } else {
      config = { REDIRECT_URL: process.env.VUE_APP_WEB_URI, IDENTITY_PROVIDER: 'azureAD', CLIENT_ID: process.env.VUE_APP_USER_POOL_CLIENT_ID, COG_URL: process.env.VUE_APP_COGNITO_URI, ID_POOL_ID: process.env.VUE_APP_ID_POOL_ID, USER_POOL_ID: process.env.VUE_APP_USER_POOL_ID }
    }

    params.append('grant_type', 'authorization_code')
    params.append('redirect_uri', encodeURI(config.REDIRECT_URL))
    params.append('identity_provider', config.IDENTITY_PROVIDER)
    params.append('code', code)
    params.append('client_id', config.CLIENT_ID)

    Axios.post(config.COG_URL + '/oauth2/token', params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      }
    })
      .then(token => {
        const bearer = 'Bearer ' + token.data.access_token
        Axios.post(config.COG_URL + '/oauth2/userInfo', {}, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': bearer
          }
        })
          .then(userInfo => {
            // localStorageを書き換え
            localStorage.setItem('CognitoIdentityServiceProvider.' + config.CLIENT_ID + '.' + userInfo.data.sub + '.accessToken', token.data.access_token)
            localStorage.setItem('CognitoIdentityServiceProvider.' + config.CLIENT_ID + '.' + userInfo.data.sub + '.idToken', token.data.id_token)
            localStorage.setItem('CognitoIdentityServiceProvider.' + config.CLIENT_ID + '.' + userInfo.data.sub + '.refreshToken', token.data.refresh_token)
            localStorage.setItem('CognitoIdentityServiceProvider.' + config.CLIENT_ID + '.' + userInfo.data.sub + '.clockDrift', 0)
            localStorage.setItem('CognitoIdentityServiceProvider.' + config.CLIENT_ID + '.LastAuthUser', userInfo.data.sub)
            // cognito関連Vuex更新
            store.commit('setUser', userInfo.data)

            Amplify.configure({
              Auth: {
                identityPoolId: config.ID_POOL_ID,
                region: process.env.VUE_APP_REGION,
                userPoolId: config.USER_POOL_ID,
                userPoolWebClientId: config.CLIENT_ID,
              },
            })

            resolve(userInfo.data)
          })
          .catch(error => {
            console.log(error)
            reject(null)
            // error 処理
            throw ('login failed')

          })
      })
      .catch(error => {
        console.log(error)
        reject(null)
        // error 処理
        throw ('login failed')
      })
  })
}

export default router
